import React from "react";
import { Grid, Box, Typography } from "@mui/material";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../../../firebase-config";
import BaseChart from "./BaseChart";

export default function CashFlowAnalysis({
  periodIndex,
  id,
  years,
  period,
}) {
  const [operatingCashFlow, setOperatingCashFlow] = React.useState([]);
  const [investingCashFlow, setInvestingCashFlow] = React.useState([]);
  const [financingCashFlow, setFinancingCashFlow] = React.useState([]);
  const [netChangeInCash, setNetChangeInCash] = React.useState([]);
  const [endCashPosition, setEndCashPosition] = React.useState([]);
  const [cashFlowYears, setcashFlowYears] = React.useState([]);
  const [name, setName] = React.useState();

  // Loading State
  const [incomeLoading, setIncomeLoading] = React.useState(true);

  async function fetchCashFlow({ id, period, periodIndex, years }) {
    setIncomeLoading(true);
    const q = query(
      collection(db, "companies-financials"),
      where("company-id", "==", id),
      where("year", "in", years),
      where("type", "==", "Cash Flow"),
      where("period", "==", period),
      where("period-index", "==", periodIndex)
    );
    const allDocs = [];
    const opActivities = [];
    const investingActivities = [];
    const financingActivities = [];
    const cashChange = [];
    const endCash = [];
    const dataYears = [];
    let companyName;

    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      allDocs.push(doc.data());
      companyName = doc.data()["name"];
    });

    allDocs.sort((a, b) => a["year"] - b["year"]);

    allDocs.forEach((doc) => {
      opActivities.push(doc["Operating Cash Flow"]);
      investingActivities.push(doc["Investing Cash Flow"]);
      financingActivities.push(doc["Financing Cash Flow"]);
      cashChange.push(doc["Net Change In Cash"]);
      endCash.push(doc["End Cash Position"])
      dataYears.push(doc["year"]);
    });

    setOperatingCashFlow(opActivities);
    setInvestingCashFlow(investingActivities);
    setFinancingCashFlow(financingActivities);
    setNetChangeInCash(cashChange);
    setEndCashPosition(endCash);
    setcashFlowYears(dataYears);
    setName(companyName);
    setIncomeLoading(false);
  }

  React.useEffect(() => {
    fetchCashFlow({
      id: id,
      period: period,
      periodIndex: periodIndex,
      years: years,
    });
  }, [years, id, period, periodIndex]);

  return incomeLoading ? (
    <h4>Loading</h4>
  ) : (
    <>
      {/* <Typography variant="h5" align="center">
        {name}
      </Typography> */}
      <Typography variant="h5" align="center">
        Cash Flow Trend
      </Typography>
      <Box>
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <BaseChart
              name="Operating Cash Flow"
              data={operatingCashFlow}
              categories={cashFlowYears}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <BaseChart
              name="Investing Cash Flow"
              data={investingCashFlow}
              categories={cashFlowYears}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <BaseChart
              name="Financing Cash Flow"
              data={financingCashFlow}
              categories={cashFlowYears}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <BaseChart
              name="Net Change in Cash"
              data={netChangeInCash}
              categories={cashFlowYears}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <BaseChart
              name="End Cash Position"
              data={endCashPosition}
              categories={cashFlowYears}
            />
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
